let dateFrom = function(val){
	if(val.length >0){
		//this.dateTo = this.sumarDias(2, val);
		console.log('dateFrom sumarDias dateTo', val)	
	}
};
export default dateFrom;
